import React, {
  ReactElement,
  useEffect,
  useRef,
  useState,
} from 'react';
import Tooltip from '@mui/material/Tooltip';

export const LinkCell = ({
                           params,
  column
}: {
  params: any,
  column: any,
}): ReactElement => {
  const divRef = useRef(null);
  const [tooltip, setTooltip] = useState(false);

  const [clickTimeout, setClickTimeout] = useState<NodeJS.Timeout | null>(null);

  const handleClick = (event: React.MouseEvent) => {
    // Ha van függőben lévő dupla kattintás, töröljük
    if (clickTimeout) {
      clearTimeout(clickTimeout);
      setClickTimeout(null);
      return;
    }

    // Indítunk egy időzítőt, hátha nem dupla kattintás
    const timeout = setTimeout(() => {
      window.open(
        `/${column?.linkUrl}/${column?.id === "activity" ? params?.row?.activity_reservation?.id : params?.value?.id}`,
        "_blank",
        "noopener,noreferrer"
      );
    }, 200); // 250ms várakozási idő az egykattintás és dupla kattintás megkülönböztetésére

    setClickTimeout(timeout);
  };

  const handleDoubleClick = () => {
    if (clickTimeout) {
      clearTimeout(clickTimeout); // Dupla kattintás esetén töröljük az egykattintásos timeoutot
      setClickTimeout(null);
    }
    params.api.startRowEditMode({ id: params.id });
  };

  // Takarítás a timeoutok elkerülésére, ha a komponens unmountolódik
  useEffect(() => {
    return () => {
      if (clickTimeout) {
        clearTimeout(clickTimeout);
      }
    };
  }, [clickTimeout]);

  let transformedValue =
    params?.value === undefined ? null : params.value;

  function getDivWidth(divRef: any) {
    if (divRef && divRef.current) {
      const divElement = divRef.current;
      const parentElement = divElement.parentNode;

      const divRect = divElement.getBoundingClientRect();
      const parentRect = parentElement.getBoundingClientRect();

      return {
        element: divRect.width,
        cell: parentRect.width,
      };
    }
    return {
      element: 0,
      cell: 0,
    };
  }

  const checkForOverflow = () => {
    if (divRef.current) {
      const element: any = divRef.current;
      return element.scrollWidth > element.clientWidth;
    }
    return false;
  };

  useEffect(() => {
    setTooltip(checkForOverflow());
  });


  return (
    <div ref={divRef}>
      {tooltip ? (
        <>
          <Tooltip
            disableInteractive
            title={''}
            slotProps={{
              tooltip: {
                sx: {
                  fontSize: '13px',
                },
              },
              popper: {
                modifiers: [
                  {
                    name: 'offset',
                    options: {
                      offset: [0, -14],
                    },
                  },
                ],
              },
            }}
          >
            <div>{''}</div>
          </Tooltip>
        </>
      ) : (
        <>
          <div
            className={'flex gap-[5px]'}
            onClick={handleClick}
            onDoubleClick={handleDoubleClick}
            style={{ cursor: "pointer" }}
          >
            {transformedValue?.name}
          </div>
        </>
      )}
    </div>
  );
};
